export const WEATHER_FETCH_START = 'weather/fetch:start';
export const WEATHER_FETCH_SUCCESS = 'weather/fetch:success';
export const WEATHER_FETCH_FAILURE = 'weather/fetch:failure';